import { AvailableItemConfigsContext } from "../../context/AvailableItemConfigContext"
import { useContext } from "react"

export const useAvailableItemConfigContext = () => {
  const context = useContext(AvailableItemConfigsContext)

  if(!context) {
    throw Error('useAvailableItemConfigContext must be used inside an AvailableItemConfigsContextProvider')
  }

  return context
}